export default "__VITE_ASSET__Cz$ByVeh__"